// Mock data for IPTGE Landing Page

export const heroData = {
  title: "Instituto Politécnico de Tecnologia e Gestão de Espinho",
  subtitle: "Formação superior em Gestão, Tecnologia e Cibersegurança — orientada para o futuro digital.",
  logo: "https://customer-assets.emergentagent.com/job_21a6a051-52ae-4878-b275-95d0125d86c7/artifacts/20jg1s2r_IPTGE-01-logo.jpg-removebg-preview.png",
  logoUnifoco: "https://customer-assets.emergentagent.com/job_21a6a051-52ae-4878-b275-95d0125d86c7/artifacts/9qf1aawb_logo%20unifoco.jpg"
};

export const aboutData = {
  title: "Quem Somos",
  content: [
    "O Instituto Politécnico de Tecnologia e Gestão de Espinho (IPTGE) é uma instituição de ensino superior focada nas áreas da Gestão, Sistemas de Informação, Recursos Humanos e Cibersegurança.",
    "Com uma forte aposta no ensino online e híbrido, o IPTGE oferece formação orientada para a empregabilidade, combinando competências técnicas, científicas e humanas, com ligação direta às necessidades do mercado de trabalho."
  ]
};

export const coursesData = {
  title: "Pós-Graduações e Formação Especializada",
  courses: [
    "Pós-Graduação em Gestão e Transformação Digital",
    "Pós-Graduação em Gestão de Marketing, Branding e Comunicação Digital",
    "Pós-Graduação em Gestão de Pessoas, Liderança e Desenvolvimento Organizacional",
    "Pós-Graduação em Estratégia do Negócio em Ambientes de Incerteza",
    "ENISA I – ENISA e Perfis Profissionais de Cibersegurança",
    "ENISA II – Qualidade, Direito Informático e Proteção de Dados",
    "ENISA III – Proteção e Previsão de Ciberataques"
  ],
  pdfLink: "https://diogoh.pt/cursos.pdf",
  pdfButtonText: "Download do PDF com informação detalhada"
};

export const contactData = {
  title: "Contactos",
  institution: "UNIFOCO – Formação e Ensino Profissional, Lda",
  address: "Rua 62, nº 380 – Espinho",
  additionalLocation: "Pólo adicional: Vila Nova de Gaia",
  email: "geral@estgespinho.com",
  phone: "220 959 975"
};

export const navItems = [
  { id: "hero", label: "Início" },
  { id: "about", label: "Quem Somos" },
  { id: "courses", label: "Cursos" },
  { id: "contact", label: "Contactos" }
];
